import { useDispatch, useSelector } from 'react-redux';
import {
  selectConfiguratorRequestFormOpen,
  setConfiguratorRequestFormOpen,
} from '../../redux/slicers/appSlicer';
import { HubspotFormModal } from '../HubspotFormModal';

export const ConfiguratorRequestForm = () => {
  const dispatch = useDispatch();
  const open = useSelector(selectConfiguratorRequestFormOpen);

  return (
    <HubspotFormModal
      title="Request"
      portalId="6917454"
      formId="2716c97a-71bd-4a55-b6b9-12b14a687949"
      open={open}
      onClose={() => dispatch(setConfiguratorRequestFormOpen(false))}
    />
  );
};
